export var RiskScoringModel;
(function (RiskScoringModel) {
    RiskScoringModel["ControlEffectivenessAverages"] = "control_effectiveness_averages";
    RiskScoringModel["Default"] = "default";
    RiskScoringModel["NumberOfControlsWithGaps"] = "number_of_controls_with_gaps";
    RiskScoringModel["TypedControlEffectivenessAverages"] = "typed_control_effectiveness_averages";
})(RiskScoringModel || (RiskScoringModel = {}));
//# sourceMappingURL=risk-scoring-model.js.map